import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-informes-mensuales',
  templateUrl: './informes-mensuales.component.html',
  styleUrls: ['./informes-mensuales.component.scss']
})
export class InformesMensualesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
